export const STORAGE_CONFIG = {
  BUCKET_NAME: 'assets',
  COMPETITION_ASSETS: {
    LOGOS: 'competitions/logos',
    DOCUMENTS: 'competitions/documents'
  },
  MAX_FILE_SIZE: 1024 * 1024 * 2, // 2MB
  CACHE_CONTROL: '3600'
};
